
import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import Api from '@/utils/api';

export default {
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  components: {
    pagination,
    preloader,
    empty,
  },
  data () {
    return {
      inconsistenciesList: [],
      popupList: [],
      diffList: [],

      typeDiff: [
        'unchanged',
        'deleted',
        'inserted',
        'imaginary',
        'modified',
      ],

      responseData: {},
      responseDataDiff: {},

      query: {
        page: 1,
        ppage: 8,
        difference_source_id: '',
      },

      queryDiff: {
        page: 1,
        ppage: 8,
        difference_source_id: '',
      },

      showCompared: false,
      load: true,
      loadDiff: true,
    };
  },
  computed: {
    showButtonText () {
      return !this.showCompared ? 'Similar segments' : 'Cancel';
    },
  },
  created () {
    this.getInconsistencies();
  },
  methods: {
    getInconsistencies () {
      this.inconsistenciesList = [];
      this.responseData = {};
      this.load = true;

      Api.reports
        .getInconsistencies(this.reportId, this.query)
        .then((data) => {
          if (data.data.Status) {
            this.responseData = data.data;
            this.inconsistenciesList = data.data.Data;
          }

          this.load = false;
        });
    },

    changeCheckbox (id, event) {
      if (this.popupList.length <= 2) {
        if (event.target.checked) {
          this.popupList.push(this.inconsistenciesList.find((el) => el.ID === id));

          if (this.popupList.length == 1) {
            this.textSelectedInitial = id;
          }

          if (this.popupList.length == 2) {
            this.textSelectedFinal = id;
          }
        } else {
          if (this.textSelectedFinal == id) {
            this.textSelectedFinal = null;
          }

          if (this.textSelectedInitial == id) {
            this.textSelectedInitial = this.textSelectedFinal;
            this.textSelectedFinal = null;
          }

          this.popupList = this.popupList.filter((el) => el.ID !== id);
        }
      }
    },

    showDiff (id) {
      !this.showCompared ? this.showCompared = id : this.showCompared = false;
      this.queryDiff.page = 1;
      this.getDiff();
    },

    getDiff () {
      this.responseDataDiff = {};
      this.diffList = [];
      this.loadDiff = true;

      this.queryDiff.difference_source_id = this.showCompared;

      Api.reports
        .getInconsistencies(this.reportId, this.queryDiff)
        .then((data) => {
          if (data.data.Status) {
            this.diffList = data.data.Data;
            this.responseDataDiff = data.data;

            this.diffList.forEach((item, index) => {
              if (index > 0) {
                this.comparedText(item, 'DiffSourceText', 'concatDiffSourceText');
                this.comparedText(item, 'DiffTargetText', 'concatDiffTargetText');
                this.comparedText(item, 'DiffCorrectedText', 'concatDiffCorrectedText');
              }
            });
          }

          this.loadDiff = false;
        });
    },

    comparedText (item, diffText, nameConcat) {
      item[nameConcat] = '';

      item[diffText].Lines.forEach((el) => {
        item[nameConcat] += `<row class="row-string ${this.typeDiff[el.Type]}">`;

        if (el.Type === 0) {
          item[nameConcat] += `<word class="word"><span>${el.Text}</span></word>`;
        }
        if (el.Type === 1) {
          item[nameConcat] += `<word class="word"><span>${el.Text}</span></word>`;
        }
        if (el.Type === 2) {
          item[nameConcat] += `<word class="word"><span>${el.Text}</span></word>`;
        }
        if (el.Type === 3) {
          item[nameConcat] += '<word class="word"><br></word>';
        }
        if (el.Type === 4) {
          el.SubPieces.forEach((subEl) => {
            item[nameConcat] += `<word class="word ${this.typeDiff[subEl.Type]}"><span>${(subEl.Text !== null && subEl.Text !== ' ') ? subEl.Text : '&nbsp;'}</span></word>`;
          });
        }

        item[nameConcat] += '</row>';
      });
    },

    sendPage (page) {
      this.query.page = page;
      this.popupList = [];
      this.getInconsistencies();
    },

    sendPageDiff (page) {
      this.queryDiff.page = page;
      this.getDiff();
    },

    back () {
      this.showCompared = false;
      this.responseDataDiff = {};
    },
  },
};
